import React, { Component } from 'react';
import classnames from 'classnames';

const Header = ({th}) => {
    const thType = {
        className: classnames(th.id.toLowerCase())
    }
    return <th {...thType}>{th.title}</th>;
}

const ListHeader = ({headerData}) => {
    return (
        <tr className="header">
            {headerData.map(th => {
                return <Header th={th} key={th.id}/>;
            }
            )}
        </tr>
    );
}

export default ListHeader;


// WEBPACK FOOTER //
// ./src/containers/downloadlog/ListHeader.js